/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-simple__subtitle[_ngcontent-%COMP%]{font-family:r-montserrat,sans-serif;font-weight:700;font-size:.9rem;padding:0 1em;margin-bottom:.8rem;color:var(--main-color);text-transform:uppercase}.form-simple__btns[_ngcontent-%COMP%]{margin-bottom:1rem}"];
export { styles as styles };
